module.exports = __webpack_public_path__ + "files/119af920deb2a00a47c41a496719a10e.png";